import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initMicrosoftClarity } from './app/shared/utils/clarity.util';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

initMicrosoftClarity(environment.clarityProjectId);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
